<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta v-if="msgAlerta" class="row-space" :mensagem="msgAlerta" />

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item" style="flex: 0 0 90px;">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdentidade) }}</div>
                </div>

                <div class="form-item-char20">
                    <label v-if="!ckCpfCnpjOk" class="label-link" @click="showModalCpfCnpj=true">CPF/CNPJ</label>
                    <label v-if="ckCpfCnpjOk" class="label-caption">CPF/CNPJ</label>
                    <div :class="{
                        'field-label-alert': !ckCpfCnpjOk,
                        'field-label': ckCpfCnpjOk,
                        'field-label-center': true}">{{ objEdicao.cpfcnpj }}</div>
                </div>

                <div class="form-item flexible">
                    <label class="label-caption" for="nmpessoa">Nome/Razão Social</label>
                    <input type="text" v-model="objEdicao.nmentidade" id="nmpessoa" required maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Endereço</label>
                    <input type="text" v-model="objEdicao.endereco" maxlength="100" v-uppercase />
                </div>
                <div class="form-item-char10">
                    <label class="label-caption">Número</label>
                    <input type="text" class="input-right" v-model="edNmEndereco" v-number maxlength="5" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Complemento</label>
                    <input type="text" v-model="objEdicao.complemento" maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Bairro</label>
                    <input type="text" v-model="objEdicao.nmbairro" maxlength="100" v-uppercase />
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">CEP</label>
                    <input type="text" v-model="objEdicao.cep" v-cep maxlength="10" />
                </div>
            </div>
            
            
            <div class="row row-space">                
                <div class="form-item-telefone">
                    <label class="label-caption" for="fone">Telefone</label>
                    <input type="text" v-model="objEdicao.fone" id="fone" v-phone maxlength="15" />
                </div>

                <div class="form-item flexible">
                    <label class="label-caption" for="email">Email</label>
                    <input type="email" v-model="objEdicao.email" id="email" />
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Nome Contato</label>
                    <input type="text" v-model="objEdicao.nmcontato" maxlength="100" v-uppercase />
                </div>
            </div>

            <div class="row-end">
                <label for="ckAtivo">Ativo</label>
                <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
            </div>


            <div class="row-end margin-top10">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>

    <CpfCnpjModal
        v-if="showModalCpfCnpj"
        @close="showModalCpfCnpj = false"
        @cpfCnpjSubmitted="arrumarCpfCnpj"
    />

    <DialogOkModal 
      v-if="showOkModal" 
      :message="msgOkModal" 
      @close="showOkModal=false" 
      @confirmed="showOkModal=false" />
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarEntidade } from '@/models/Entidade';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import CpfCnpjModal from '@/components/modals/CpfCnpjModal.vue';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit=defineEmits(['close', 'salvo']);
const props=defineProps({
    idEdicao: {type: Number, default: 0},
    cpfCnpjNovo: {type: String, default: ''}});

const ckAtivo = ref(false);
const ckCpfCnpjOk= ref(true);
const edNmEndereco = ref(null);
const objEdicao = criarEntidade();
const isLoading = ref(false);
const msgAlerta = ref(null);
const msgOkModal = ref(null);
const showModalCpfCnpj = ref(false);
const showOkModal = ref(false);

async function arrumarCpfCnpj(value){
    showModalCpfCnpj.value=false;
    try{
        msgAlerta.value  = null;
        isLoading.value     = true;
        const r = await Api.genericPut('/cad/entidade', {
            id: objEdicao.id,
            cpfcnpj: value, 
            idusuario: globalStore.idusuario});
        if (r.bolok == 1){objEdicao.cpfcnpj = value; ckCpfCnpjOk.value=true;}else{msgAlerta.value = r.error}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally {isLoading.value = false;}
}

const submitForm = async () => {
    try {
        isLoading.value=true;
        objEdicao.ckativo = ckAtivo.value ? 'S' : 'N';
        objEdicao.nmendereco = Funcoes.integerFromString(edNmEndereco.value);
        const response = await Api.genericPut('/cad/entidade', objEdicao);
        if (response.bolok===1){
            emit('salvo');
            emit('close');
        }else{
            msgAlerta.value = `ATENÇÃO: ${response.erro}`
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
};

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value=true;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('entidade', props.idEdicao);
                Object.assign(objEdicao, req[0]);
            }catch (error){console.error('Erro leitura dos dados', error);}
        }else{
            objEdicao.idmunicipio = globalStore.idmunicipio;
            objEdicao.cpfcnpj = props.cpfCnpjNovo;
        }
        objEdicao.idusuario     = globalStore.idusuario;
        ckAtivo.value           = objEdicao.ckativo==='S';
        edNmEndereco.value      = Funcoes.formatInteger(objEdicao.nmendereco);
        try{
            Funcoes.validarCNPJouCPF(objEdicao.cpfcnpj);
            ckCpfCnpjOk.value=true;
        }catch (error){ckCpfCnpjOk.value=false}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}

onMounted(lerDados);
</script>